import React from 'react';
import PropTypes from 'prop-types';

import getRadius from 'lib/getRadius';
import overrideStyle from 'lib/overrideStyle';

export default function PaymentRequestMessageItem(props) {
  return (
    <PaymentRequestMessage>
      <div>{props.amount || '$176.27'}</div>
      <ButtonWrapper>
        <Button>Pay</Button>
        <Button>Decline</Button>
      </ButtonWrapper>
    </PaymentRequestMessage>
  );
}

PaymentRequestMessageItem.propTypes = {
  amount: PropTypes.string,
};

const ButtonWrapper = overrideStyle('div')`
  display: flex; 
  flex-direction: row;
  width: 100%;
`;

const Button = overrideStyle('div')`
  border-radius: ${p => getRadius(p.theme.borderRadius, 8, 16)};
  border: 1px solid black;
  padding: 30px;
  font-family: ${p => p.theme.fontLibrary.primary};
`;

const Message = overrideStyle('div')`
  border-radius: ${p => getRadius(p.theme.borderRadius, 8, 16)};
  border: 1px solid black;
  flex: 0 0 auto;
  font-family: ${p => p.theme.fontLibrary.primary};
  padding: 10px 15px;
`;

const PaymentRequestMessage = overrideStyle(Message)`
  height: 100px;
  align-self: center;
  width 300px;
`;
